import { useTranslation } from 'react-i18next';

import { LanguageObject } from '@/types';

import InputDialog from 'components/Dialogs/InputDialog';
import { getNameFromLanguage } from 'utils/language';

interface RenameQuizPopupProps {
  showRenameQuizPopup: boolean;
  setShowRenameQuizPopup: (show: boolean) => void;
  onRenameQuizAndClosePopup: (inputValue: string) => void;
  quizDetails: { name: LanguageObject };
}

const RenameQuizPopup: React.FC<RenameQuizPopupProps> = ({
  showRenameQuizPopup,
  setShowRenameQuizPopup,
  onRenameQuizAndClosePopup,
  quizDetails,
}) => {
  const { t } = useTranslation();

  return (
    <InputDialog
      headerText={t('Generic.giveNewName', { object: t('Generic.quiz') })}
      isOpen={showRenameQuizPopup}
      keyDownEnter={true}
      onClose={() => setShowRenameQuizPopup(false)}
      primaryButtonHandler={onRenameQuizAndClosePopup}
      primaryButtonText={t('Button.update')}
      primaryButtonVariant="filled"
      secondaryButtonHandler={() => setShowRenameQuizPopup(false)}
      secondaryButtonText={t('Button.cancel')}
      textInputDefaultValue={getNameFromLanguage(quizDetails.name)}
    />
  );
};

export default RenameQuizPopup;
